import { render } from "preact";
import { App } from "./app";
import { loadConfig } from "./config";
import "./styles.css";

const root = document.getElementById("app")!;

loadConfig()
  .then(async (config) => {
    // The presenter's phone remote is its own chunk: participants never download it.
    if (location.pathname === "/remote") (await import("./remote")).mountRemote(root, config);
    else render(<App config={config} />, root);
  })
  .catch((err: unknown) => {
    // Nothing can work without knowing where the server is; say so plainly rather than
    // render a join form that cannot submit. Not translated: the catalog is chosen
    // later, and this is an operator's configuration error, not a participant's.
    console.error(err);
    root.textContent = "This app is not configured correctly. Please tell the organiser.";
  });
